module.exports = __webpack_public_path__ + "static/preview-a0afbfa1301ab586fc08ca2e07e144a6.png";